import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import {changePageNext} from "@/utils";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/user',
    name: 'User',
    meta: {requiresAuth: true},
    component: () => import('@/views/UserView.vue')
  },
  {
    path: '/sale/list/:markId?',
    name: 'saleList',
    meta: {requiresAuth: true},
    component: () => import('@/views/sale/SaleListView.vue')
  },
  {
    path: '/sale/:id',
    name: 'saleDetail',
    meta: {requiresAuth: true},
    component: () => import('@/views/sale/SaleDetailView.vue')
  },
  {
    path: '/area/list',
    name: 'areaList',
    component: () => import('@/views/area/AreaListView.vue')
  },
  {
    path: '/area/:cont/:country',
    name: 'areaDetail',
    meta: {parent: "/area/list"},
    component: () => import('@/views/area/AreaDetailView.vue')
  },
  {
    path: '/schedule/:serviceType/:type',
    name: 'scheduleDetail',
    component: () => import('@/views/schedule/ProfessionalScheduleView.vue')
  },
  {
    path: '/qa',
    name: 'Qa',
    component: () => import('@/views/qa/QaView.vue')
  },
  {
    path: '/news/list/:categoryId?',
    name: 'NewsList',
    component: () => import('@/views/news/NewsListView.vue')
  },
  {
    path: '/news/detail/:id?',
    name: 'NewsDetail',
    component: () => import('@/views/news/NewsDetailView.vue')
  },
  {
    path: '/risk/list',
    name: 'RiskList',
    component: () => import('@/views/risk/RiskListView.vue')
  },
  {
    path: '/risk/detail/:id?',
    name: 'RiskDetail',
    component: () => import('@/views/risk/RiskDetailView.vue')
  },
  {
    path: '/activity/list',
    name: 'ActivityList',
    component: () => import('@/views/activity/ActivityListView.vue')
  },
  {
    path: '/activity/detail/:id?',
    name: 'ActivityDetail',
    meta: {parent: "/activity/list"},
    component: () => import('@/views/activity/ActivityDetailView.vue')
  },
  {
    path: '/activityPlan/list',
    name: 'ActivityPlanList',
    component: () => import('@/views/activityPlan/ActivityPlanListView.vue')
  },
  {
    path: '/activityPlan/detail/:id?',
    name: 'ActivityPlanDetail',
    meta: {parent: "/activityPlan/list"},
    component: () => import('@/views/activityPlan/ActivityPlanDetailView.vue')
  },
  {
    path: '/search',
    name: 'Search',
    meta: {requiresAuth: true},
    component: () => import('@/views/search/SearchListView.vue')
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => {
      if (location.href.indexOf("cn.") > 0) {
        return import('@/views/other/WelcomeChinaView.vue')
      } else {
        return import('@/views/other/WelcomeOutView.vue')
      }
    }
  },
  {
    path: '/welcomeChina',
    name: 'welcomeChina',
    component: () => import('@/views/other/WelcomeChinaView.vue')
  },
  {
    path: '/welcomeOc',
    name: 'welcomeOc',
    component: () => import('@/views/other/WelcomeView.vue')
  },
  {
    path: '/devAndReform',
    name: 'DevAndReform',
    component: () => import('@/views/other/DevAndReformView.vue')
  },
  {
    path: '/commerce',
    name: 'Commerce',
    component: () => import('@/views/other/CommerceView.vue')
  },
  {
    path: '/foreigner',
    name: 'Foreigner',
    component: () => import('@/views/other/ForeignerView.vue')
  },
  {
    path: '/overseas',
    name: 'Overseas',
    component: () => import('@/views/other/OverseasView.vue')
  },

  {
    path: '/public_service/apec',
    name: 'Apec',
    component: () => import('@/views/publicService/1/ApecView.vue')
  },
  {
    path: '/public_service/special_visa',
    name: 'SpecialVisa',
    component: () => import('@/views/publicService/1/SpecialVisaView.vue')
  },
  {
    path: '/public_service/talent',
    name: 'Talent',
    component: () => import('@/views/publicService/1/TalentView.vue')
  },
  {
    path: '/public_service/overseas_chinese',
    name: 'OverseasChinese',
    component: () => import('@/views/publicService/1/OverseasChineseView.vue')
  },
  {
    path: '/public_service/visa_financial',
    name: 'VISAFinancial',
    component: () => import('@/views/publicService/1/VISAFinancialView.vue')
  },
  {
    path: '/public_service/certification',
    name: 'CertificationView',
    component: () => import('@/views/publicService/1/CertificationView.vue')
  },
  {
    path: '/public_service/odi',
    name: 'ODIView',
    component: () => import('@/views/publicService/2/ODIView.vue')
  },
  {
    path: '/public_service/ft',
    name: 'FTView',
    component: () => import('@/views/publicService/2/FTView.vue')
  },
  {
    path: '/public_service/aeo',
    name: 'AEOView',
    component: () => import('@/views/publicService/3/AEOView.vue')
  },
  {
    path: '/public_service/warehouse',
    name: 'WarehouseView',
    component: () => import('@/views/publicService/3/WarehouseView.vue')
  },
  {
    path: '/public_service/rcep',
    name: 'RCEPView',
    component: () => import('@/views/publicService/3/RCEPView.vue')
  },
  {
    path: '/public_service/trade',
    name: 'TradeView',
    component: () => import('@/views/publicService/3/TradeView.vue')
  },
  {
    path: '/public_service/channel',
    name: 'ChannelView',
    component: () => import('@/views/publicService/4/ChannelView.vue')
  },
  {
    path: '/public_service/cross_border',
    name: 'CrossBorderView',
    component: () => import('@/views/publicService/4/CrossBorderView.vue')
  },
  {
    path: '/public_service/global_internet',
    name: 'GlobalInternetView',
    component: () => import('@/views/publicService/4/GlobalInternetView.vue')
  },
  {
    path: '/public_service/madrid',
    name: 'MadridView',
    component: () => import('@/views/publicService/5/MadridView.vue')
  },
  {
    path: '/public_service/copyright',
    name: 'CopyrightView',
    component: () => import('@/views/publicService/5/CopyrightView.vue')
  },
  {
    path: '/public_service/ip_rights',
    name: 'IPRightsView',
    component: () => import('@/views/publicService/5/IPRightsView.vue')
  },
  {
    path: '/public_service/intellectual_property',
    name: 'IntellectualPropertyView',
    component: () => import('@/views/publicService/5/IntellectualPropertyView.vue')
  },
  {
    path: '/public_service/:type?',
    name: 'PublicServiceView',
    component: () => import('@/views/publicService/PublicServiceView.vue')
  },
  {
    path: '/madrid',
    name: 'MadridView',
    component: () => import('@/views/other/MadridView.vue')
  },
  {
    path: '/logOut',
    name: 'logOutView',
    component: () => import('@/views/LoginOutView.vue')
  },
  {
    path: '/odi',
    name: 'odi',
    component: () => import('@/views/other/ODIView.vue')
  },
  {
    path: '/service/:type?/:childType?',
    name: 'ServiceView',
    component: () => import('@/views/other/ServiceView.vue')
  },
  {
    path: '/company/:type/:childType/:id',
    name: 'CompanyDetailView',
    component: () => import('@/views/other/CompanyDetailView.vue')
  },
  {
    path: '/manager/schedule',
    name: 'ScheduleManager',
    meta: {requiresAuth: true},
    component: () => import('@/views/manager/schedule/ScheduleManagerView.vue')
  },
  { path: "/:pathMatch(.*)", redirect: "/", name: "notMatch", hidden: true },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('setReady', false)
  if(store.getters.token){
    if(store.getters.user) {
      next();
    } else {
      store.dispatch('user/GetInfo').then(() => {
        next();
      },() => {
        store.dispatch('user/LogOut').then(() => {
          if (to.matched.some(record => record.meta.requiresAuth)) {
            changePageNext(next, {path: "/login"}, to.path)
          } else {
            next();
          }
        })
      })
    }
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      changePageNext(next, {path: "/login"}, to.path)
    } else {
      next();
    }
  }
});

export default router
